<template>
  <div>
    <ticket-search
      :get-status="getUserCaseStatus"
      :get-user-cases="getUserCases"
      :get-comment-history="getCommentHistory"
      :get-case-documents="getUserCaseById"
      :delete-case="deleteCase"
      :save-additional-info="saveAdditionalInfo"
      :save-comment-management="saveCommentManagement"
      :download-document="downloadDocument"
      :change-status-ticket="changeStatusTicket"
      :status-id="statusId"
      @on-open-case="onOpenCaseHandler"
      :can-show-toggle-type="canShowToggleType"
      class="ticket-search__extended"
    />
  </div>
</template>

<script>
import { TicketSearch } from "support-tickets";
import {
  getUserCases as _getUserCases,
  getUserCaseStatus as _getUserCaseStatus,
  deleteCase as _deleteCase,
  saveAdditionalInfo as _saveAdditionalInfo,
  saveCommentManagement as _saveCommentManagement,
  getCommentHistory as _getCommentHistory,
  changeStatusTicket as _changeStatusTicket,
  downloadDocument as _downloadDocument,
  getUserCaseById as _getUserCaseById
} from "@/modules/helpdesk/api.js";
import userRolesIds from '@/utils/constants/userRolesIds'

export default {
  name: "CaseListMain",
  components: { TicketSearch },
  computed: {
    statusId() {
      return this.$route.params.status;
    },
    canShowToggleType(){       
      return this.userProfile.roleId.toLowerCase() == userRolesIds.director.toLowerCase()
      || this.userHasPermissions('help.referredoretickets')
    }
  },
  methods: {
    getUserCases(params, pageIndex, pageSize) {
      return _getUserCases(params, pageIndex, pageSize);
    },
    getUserCaseStatus(deptIds) {
      return _getUserCaseStatus(deptIds);
    },
    onOpenCaseHandler(item) {
      const { id } = item;

      this.$router.push({ name: "DetailsTicket", params: { id } });
    },
    deleteCase(id) {
      return _deleteCase(id);
    },
    saveAdditionalInfo(formData) {
      return _saveAdditionalInfo(formData);
    },
    saveCommentManagement(formData) {
      return _saveCommentManagement(formData);
    },
    downloadDocument(documentId) {
      return _downloadDocument(documentId);
    },
    getUserCaseById(itemId) {
      return _getUserCaseById(itemId);
    },
    getCommentHistory(caseNumber) {
      return _getCommentHistory(caseNumber);
    },
    changeStatusTicket(data)
    {
      return _changeStatusTicket(data);
    }
  }
};
</script>

<style scoped lang="scss">
:deep(.ticket-search__extended) {
  .actions {
    display: none;
  }
}
</style>
